import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app/selected.svg'
import _imports_1 from '@/assets/app/delete-app.svg'
import _imports_2 from '@/assets/app/default_app.svg'


const _withScopeId = n => (_pushScopeId("data-v-df67f148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addRules" }
const _hoisted_2 = { class: "setRule" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ruleDetails" }, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "options" }
const _hoisted_7 = { class: "one" }
const _hoisted_8 = { class: "two" }
const _hoisted_9 = { class: "ending" }
const _hoisted_10 = {
  key: 0,
  class: "selectStatus",
  src: "@/assets/app/unSelected.svg"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_0
}
const _hoisted_12 = { class: "secondCheck" }
const _hoisted_13 = {
  key: 0,
  class: "selectStatus",
  src: "@/assets/app/unSelected.svg"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_0,
  class: "selectStyle"
}
const _hoisted_15 = { class: "custom" }
const _hoisted_16 = { class: "week" }
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { style: {"padding":"0 20px","line-height":"34px"} }
const _hoisted_19 = { class: "time" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "allTime" }
const _hoisted_22 = { class: "selectApp" }
const _hoisted_23 = { class: "appTitle title" }
const _hoisted_24 = { class: "selected" }
const _hoisted_25 = {
  key: 0,
  class: "defaultContent"
}
const _hoisted_26 = {
  key: 1,
  class: "selectedApps defaultContent swiper-box",
  id: "selectedApps"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  src: _imports_2,
  class: "appLogo"
}
const _hoisted_30 = { class: "disableApps" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  src: _imports_2,
  class: "right-img"
}
const _hoisted_33 = { class: "appName" }
const _hoisted_34 = { class: "oprate" }

import { defineComponent, ref, onMounted, computed, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getUnblockApp } from "@/api/devices";
import { ElMessage } from "element-plus";
import HourPicker from './hourPicker.vue'; // 导入自定义组件的路径
import { numberToString, numberToWeek, calculateDuration, formatToTime, checkFormat } from "@/views/screen/component/fomat";
import Swiper from 'swiper';
// import 'swiper/swiper.css'
// import {Autoplay} from 'swiper'
import { gaEvent } from "@/utils/format";



export default /*#__PURE__*/_defineComponent({
  __name: 'addRules',
  props: {
  // 是否为新增
  isNew: {
    type: Boolean,
    default: true,
  },
  showData: {
    type: Object,
    default: {}
  },
  editGtag: {
    type: Boolean,
    default: false,
  }
},
  emits: ["closeAdd", 'close'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const { t } = useI18n();
const id = computed(() => {
  return store.state.currentDeviceId;
});
const currentLang = computed(() => {
  return store.state.currentLang;
});
const isVibe = computed(() => !store.state.isVibe);
const undisableList = ref<any[]>([])





let appWrapHeight = 315

const editRuleId = ref('')

const selectedHour = ref()
watch(() => props.isNew, (newV) => {
  console.log('selectedHour', props.showData, props.isNew);
  appWrapHeight = 315
  if (!newV) {
    nextTick(() => {
      checkApp.value = props.showData.apps
      if (props.showData.cycle == 127 && props.showData.block_start_time == "00:00" && props.showData.block_end_time == "24:00") {
        console.log('always');
        permanently.value = true
        editRuleId.value = props.showData.id
        // handleCheckAllChange()
        // selectedOptions.value = ['Every Monday','Every Tuesday','Every Wednesday','Every Thursday','Every Friday','Every Saturday','Every Sunday']
      } else {
        console.log('else');
        customDisable.value = true
        let getEditWeek = []
        if (props.showData.cycle) {
          getEditWeek = numberToString(props.showData.cycle)
          selectedOptions.value = getEditWeek
        }
        if (selectedOptions.value.length == weekOptions.length) {
          checkAll.value = true
        }
        editRuleId.value = props.showData.id
        if (!props.showData.block_start_time && !props.showData.block_end_time) {
          timeRange.value = ['', '']
        } else {
          const currentDate = new Date(); // 获取当前日期对象
          const startString = `${currentDate.toDateString()} ${props.showData.block_start_time}:00`; // 将时间字符串拼接到日期字符串中
          const endString = `${currentDate.toDateString()} ${props.showData.block_end_time}:00`; // 将时间字符串拼接到日期字符串中
          console.log('props.showData.block_start_time', startString, endString);

          timeRange.value = [startString, endString]
          // 计算total时间
          getTimeRange([props.showData.block_start_time, props.showData.block_end_time])
          console.log('props.showData.block_start_time', timeRange.value);
        }

      }

      // 动态计算回显的高度
      if (checkApp.value) {
        appWrapHeight = appWrapHeight - customFloor(props.showData.apps.length) * 46
        console.log('appWrapHeight', appWrapHeight);

        const divElement = document.getElementById('appWrap');

        // 计算内容的高度，并设置为 div 元素的高度
        const contentHeight = divElement.scrollHeight;
        divElement.style.height = appWrapHeight + 'px';
      }
    })
  } else {
    nextTick(() => {
      permanently.value = true

      // 获取要调整高度的 div 元素
      const divElement = document.getElementById('appWrap');

      // 计算内容的高度，并设置为 div 元素的高度
      const contentHeight = divElement.scrollHeight;
      divElement.style.height = appWrapHeight + 'px';
    })
  }
}, {
  immediate: true
})


onMounted(() => {
  getAllUndisable()
  gaEvent("APPBlock_EditPV", {
    event_category: "APPBlock",
    event_label: "None",
  });
})

const getAllUndisable = async () => {
  try {
    const res = await getUnblockApp(id.value);
    console.log('res', res);
    if (res.data.code == 200 && res.data.message == 'OK') {
      undisableList.value = res.data.data.unblock_apps
    }
  } catch {
  }
}

// 永久禁用
const permanently = ref(false)
// 禁用时间段
const customDisable = ref(false)

const changeDisable = () => {
  if (customDisable.value) {
    permanently.value = !permanently.value
    customDisable.value = !customDisable.value
  }
}

const changeCustom = () => {
  if (permanently.value) {
    customDisable.value = !customDisable.value
    permanently.value = !permanently.value
  }
}

const weekOptions = [
  {
    label: t('famikeep200.Every Monday'),
    value: 0b00100000
  },
  {
    label: t('famikeep200.Every Tuesday'),
    value: 0b00010000
  }, {
    label: t('famikeep200.Every Wednesday'),
    value: 0b00001000
  }, {
    label: t('famikeep200.Every Thursday'),
    value: 0b00000100
  }, {
    label: t('famikeep200.Every Friday'),
    value: 0b00000010
  }, {
    label: t('famikeep200.Every Saturday'),
    value: 0b00000001
  }, {
    label: t('famikeep200.Every Sunday'),
    value: 0b01000000
  },
]
const selectedOptions = ref([])
const checkAll = ref(false)
const isIndeterminate = ref(false)

// 下拉框选择事件
const handleSelect = (value: any) => {
  console.log('value', value);
  const checkedCount = value.length;
  checkAll.value = checkedCount === weekOptions.length;
  isIndeterminate.value = checkedCount > 0 && checkedCount < weekOptions.length;
  console.log("selectedOptions1：", selectedOptions.value);
  console.log('isIndeterminate.value', isIndeterminate.value);


}
// 全选事件
const handleCheckAllChange = (val: any) => {
  const data = weekOptions.map(item => {
    return item.label
  })
  console.log("val:", val);
  console.log("data:", data);
  console.log("selectedOptions2：", selectedOptions.value);

  selectedOptions.value = val ? data : [];
  isIndeterminate.value = false;
}
// 获取选择的时间范围
const timeRange = ref([])

const allTime = ref('')
const getTimeRange = (timerange: []) => {
  console.log('timerange', timerange);
  timeRange.value = timerange
  const timeAll = calculateDuration(timeRange.value[0], timeRange.value[1])
  allTime.value = `${timeAll[0]}h${timeAll[1]}m`
  console.log('allTime', allTime.value);
}

const clearAllTime = () => {
  allTime.value = ""
}

const checkApp = ref([])
const checkAppChange = (e: any) => {
  Swiper.value = new Swiper('.swiper-container', {
    // pagination: '.swiper-pagination',
    slidesPerView: 11,
    centeredSlides: true,
    paginationClickable: true,
    spaceBetween: 0,
    grabCursor: true
  });
  console.log('eeeeee', e, checkApp.value);
}

const deleteCurrApps = (packageName: String) => {
  console.log('packageName', packageName);
  const newArr = checkApp.value.filter((item: any) => {
    return item.package_name !== packageName
  })
  checkApp.value = newArr
}

watch(checkApp, (newV, oldV) => {
  if (newV.length > oldV.length) {
    appWrapHeight = 315 - customFloor(newV.length) * 46
  } else {
    appWrapHeight = customFloor(newV.length) * 46 + 315
  }
  // 获取要调整高度的 div 元素
  const divElement = document.getElementById('appWrap');

  // 计算内容的高度，并设置为 div 元素的高度
  const contentHeight = divElement.scrollHeight;
  divElement.style.height = appWrapHeight + 'px';
})

// 计算高度的增加和减少幅度
const customFloor = (value: any) => {
  if (value % 10 === 0) {
    if (value / 10 > 1) {
      return Math.floor(value / 10) - 1
    } else {
      return 0;
    }
  } else {
    return Math.floor(value / 10);
  }
}

let appsList = []
const cycle = ref(0b0)
const block_start_time = ref('')
const block_end_time = ref('')

const emitObj = {}

const saveRule = () => {
  console.log('wwwwwwww', permanently.value, customDisable.value);

  gaEvent("APPBlock_Save", {
    event_category: "APPBlock",
    event_label: "None",
  });
  if (isVibe.value) {
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  checkApp.value.forEach((item: any) => {
    appsList.push(item.package_name)
  })
  if (permanently.value) {
    cycle.value = 127
    block_start_time.value = "00:00"
    block_end_time.value = "24:00"
    gaEvent("APPBlock_Rule", {
      event_category: "APPBlock",
      event_label: "Always",
    });
    gaEvent("APPBlock_Amount", {
      event_category: "APPBlock",
      event_label: appsList.length,
    });
    gaEvent("APPBlock_Date", {
      event_category: "APPBlock",
      event_label: 'everyday',
    });
    gaEvent("APPBlock_Day", {
      event_category: "APPBlock",
      event_label: '24h',
    });
  } else {
    gaEvent("APPBlock_Rule", {
      event_category: "APPBlock",
      event_label: "Customize",
    });
    gaEvent("APPBlock_Day", {
      event_category: "APPBlock",
      event_label: allTime.value,
    });
    gaEvent("APPBlock_Amount", {
      event_category: "APPBlock",
      event_label: appsList.length,
    });
    console.log('selectedOptions', selectedOptions.value);
    selectedOptions.value.forEach((item: any) => {
      weekOptions.forEach((item2: any) => {
        // console.log('item2',item2,item);
        if (item2.label == item) {
          cycle.value = cycle.value + item2.value
          // console.log('cycle.value',cycle.value);
        }
      })
    })
    const getEditWeek = numberToWeek(cycle.value)
    console.log('getEditWeek', getEditWeek);
    gaEvent("APPBlock_Date", {
      event_category: "APPBlock",
      event_label: getEditWeek,
    });
    console.log('timeRange.value.length', timeRange.value.length);

    if (timeRange.value.length) {
      block_start_time.value = timeRange.value[0]
      block_end_time.value = timeRange.value[1]
    } else {
      block_start_time.value = '00:00'
      block_end_time.value = "00:00"
    }
  }
  console.log('editRuleId.value', editRuleId.value);
  // console.log('----',formatToTime(block_start_time.value),formatToTime(block_end_time.value));


  emit('closeAdd', {
    'appsList': appsList,
    'cycle': cycle.value,
    'block_start_time': checkFormat(block_start_time.value) ? formatToTime(block_start_time.value) : block_start_time.value,
    'block_end_time': checkFormat(block_end_time.value) ? formatToTime(block_end_time.value) : block_end_time.value,
    'isUpdate': props.isNew,
    'id': editRuleId.value
  })
}

const backTo = () => {
  gaEvent("APPBlock_Return", {
    event_category: "APPBlock",
    event_label: "None",
  });
  emit('close')
}


return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('famikeep200.Set disable rules')), 1),
        _createVNode(_component_el_popover, {
          placement: "bottom-start",
          width: 328,
          trigger: "hover",
          "popper-class": "rulePop"
        }, {
          reference: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('famikeep200.Disable options:')), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("famikeep200.one Disable permanently")), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("famikeep200.two Custom disable time")), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('famikeep200.You can only choose one of the two setting options')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        onClick: changeDisable,
        class: "firstCheck"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Disable permanently')), 1),
        (!permanently.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
          : (_openBlock(), _createElementBlock("img", _hoisted_11))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "label",
          onClick: changeCustom
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Custom disable time')), 1),
          (!customDisable.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13))
            : (_openBlock(), _createElementBlock("img", _hoisted_14))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('famikeep200.Disable period')), 1),
            _createVNode(_component_el_select, {
              multiple: "",
              clearable: "",
              modelValue: selectedOptions.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptions).value = $event)),
              placeholder: _unref(t)(`famikeep200.please choose`),
              onChange: handleSelect,
              disabled: !customDisable.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_checkbox, {
                    indeterminate: isIndeterminate.value,
                    modelValue: checkAll.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
                    onChange: handleCheckAllChange,
                    style: {"display":"flex","flex-direction":"row-reverse","align-items":"center","justify-content":"space-between","padding-right":"12px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('famikeep200.Daily')), 1)
                    ]),
                    _: 1
                  }, 8, ["indeterminate", "modelValue"])
                ]),
                _createVNode(_component_el_checkbox_group, {
                  modelValue: selectedOptions.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOptions).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekOptions, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            style: {"pointer-events":"none","display":"flex","flex-direction":"row-reverse","align-items":"center","justify-content":"space-between"},
                            label: item.label
                          }, null, 8, ["label"])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('famikeep200.Time')), 1),
            _createVNode(HourPicker, {
              modelValue: selectedHour.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedHour).value = $event)),
              onEmitTimeRange: getTimeRange,
              timeRange: timeRange.value,
              onClearAllTime: clearAllTime,
              isDisable: !customDisable.value
            }, null, 8, ["modelValue", "timeRange", "isDisable"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            (currentLang.value == 'ko')
              ? _withDirectives((_openBlock(), _createElementBlock("span", { key: 0 }, _toDisplayString(_ctx.$t('famikeep200.Total')) + _toDisplayString(allTime.value), 513)), [
                  [_vShow, allTime.value]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("span", { key: 1 }, _toDisplayString(allTime.value) + _toDisplayString(_ctx.$t('famikeep200.Total')), 513)), [
                  [_vShow, allTime.value]
                ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('famikeep200.Select the applications you want to disable')), 1),
      _createElementVNode("div", _hoisted_24, [
        (checkApp.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('famikeep200.Please select an application below')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkApp.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["singleApp", index >= 10 ? 'addMargin' : '']),
                  key: item.package_name
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "deleteApp",
                    onClick: ($event: any) => (deleteCurrApps(item.package_name))
                  }, null, 8, _hoisted_27),
                  (item.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.logo,
                        class: "appLogo"
                      }, null, 8, _hoisted_28))
                    : (_openBlock(), _createElementBlock("img", _hoisted_29))
                ], 2))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: checkApp.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkApp).value = $event)),
          class: "appWrap",
          onChange: checkAppChange,
          id: "appWrap"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(undisableList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                class: "appItems",
                label: item,
                key: item.package_name
              }, {
                default: _withCtx(() => [
                  (item.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.logo,
                        class: "right-img"
                      }, null, 8, _hoisted_31))
                    : (_openBlock(), _createElementBlock("img", _hoisted_32)),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", {
        class: _normalizeClass(["save opateBtn", _ctx.disableSave ? 'disableSave' : '']),
        onClick: saveRule
      }, _toDisplayString(_ctx.$t('famikeep200.Save')), 3),
      _createElementVNode("div", {
        class: "back opateBtn",
        onClick: backTo
      }, _toDisplayString(_ctx.$t('famikeep200.Back')), 1)
    ])
  ]))
}
}

})